import { Layout, Typography, Row, Col, Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import HeroSection from "../components/HeroSection";
import RequestAccessModal from "../components/RequestAccessModal";
import ControlCard from "../components/ControlCard";
import { useState } from "react";
import { CustomFooter } from "../components/Footer";

// Import JSON data
import controlsData from "../data/controls.json";
import LogoHeader from "../components/LogoHeader";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

export default function FedRAMP20xLowPage() {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const performSearch = (searchValue) => {
    if (!searchValue.trim()) {
      setSearchTerm("");
      setSearchResults([]);
      return;
    }

    const searchLower = searchValue.toLowerCase();
    const controls = controlsData;

    // Only search through fedramp20x controls for this route
    const filteredControls = controls.fedramp20x.filter(
      (control) =>
        control.id.toLowerCase().includes(searchLower) ||
        control.description.toLowerCase().includes(searchLower)
    );

    setSearchTerm(searchValue);
    setSearchResults(filteredControls);
  };

  const onSearch = (value) => {
    performSearch(value);
  };

  const controls = controlsData;
  const fedramp20xControls = controls.fedramp20x;

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <LogoHeader />

      <Content style={{ padding: "48px 0", backgroundColor: "#fff" }}>
        <div
          style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 24px" }}
        >
          <Breadcrumb
            style={{ marginBottom: "12px" }}
            items={[
              {
                title: <Link to="/">Trust Center</Link>,
              },
              {
                title: <Link to="/controls">Controls</Link>,
              },
              {
                title: "FedRAMP 20x Low",
              },
            ]}
          />

          <HeroSection
            title="Controls"
            onRequestAccess={showModal}
            onSearch={onSearch}
          />

          {searchTerm ? (
            // Search Results Section
            <section style={{ marginBottom: "64px" }}>
              <div
                style={{
                  marginBottom: "8px",
                  paddingTop: "1px",
                }}
              >
                <Title level={2}>Search Results for "{searchTerm}"</Title>
                <Paragraph style={{ color: "#666", marginBottom: "24px" }}>
                  Found {searchResults.length} matching FedRAMP 20x Low control
                  {searchResults.length !== 1 ? "s" : ""}
                </Paragraph>

                <Row gutter={[24, 24]}>
                  {searchResults.map((control, index) => (
                    <Col xs={24} md={8} key={index}>
                      <ControlCard control={control} />
                    </Col>
                  ))}
                </Row>
              </div>
            </section>
          ) : (
            // Default Section
            <section style={{ marginBottom: "64px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "8px",
                }}
              >
                <Title level={2}>FedRAMP 20x Low</Title>
              </div>
              <Paragraph
                style={{
                  color: "#666",
                  marginBottom: "24px",
                  fontSize: "16px",
                }}
              >
                Controls are the specific safeguards or security requirements
                put in place to reduce risk and protect systems, data, and
                operations.
              </Paragraph>

              <Row gutter={[24, 24]}>
                {fedramp20xControls.map((control, index) => (
                  <Col xs={24} md={8} key={index}>
                    <ControlCard control={control} />
                  </Col>
                ))}
              </Row>
            </section>
          )}
        </div>
      </Content>

      <CustomFooter />

      <RequestAccessModal
        visible={isModalVisible}
        onCancel={handleModalCancel}
      />
    </Layout>
  );
}
